var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgV = function SvgV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 38 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.333 22.125-8.75-8.75-2.916 2.917 11.666 11.667 25-25L34.417.042z"
  })));
};
export { SvgV as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAzOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjMzMzQgMjIuMTI1M0wzLjU4MzQxIDEzLjM3NTNMMC42NjY3NDggMTYuMjkyTDEyLjMzMzQgMjcuOTU4N0wzNy4zMzM0IDIuOTU4NjZMMzQuNDE2NyAwLjA0MTk5MjJMMTIuMzMzNCAyMi4xMjUzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";